import React, { useEffect, useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';


const OurInterns = () => {
  const [showScroll, setShowScroll] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {
      const totalHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const progress = totalHeight > 0 ? (window.scrollY / totalHeight) * 100 : 0;

      setScrollProgress(progress);
      setShowScroll(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Rotating card background colors
  const cardColors = ["bg-indigo-950", "bg-blue-700", "bg-indigo-600", "bg-indigo-500"];

  // Intern data list
  const interns = useMemo(() => [
    { img: '/img/rani.jpg', name: 'P. Rani', role: 'Software Engineer - Intern' },
    
    
    // { img: '/img/nadeem].jpg', name: 'Nadeem', role: 'Software Engineer - Intern (Backend)' },
    
    
    // { img: '/img/rahul.jpg', name: 'T Rahul', role: 'Software Engineer - Intern' },
    { img: '/img/rama.jpg', name: 'S. Rama Krishna', role: 'Software Engineer - Intern' },
    { img: '/img/sravani.jpg', name: 'G. Sravani', role: 'Software Engineer - Intern' },
    { img: '/img/siva.jpg', name: 'M. Siva', role: 'Software Engineer - Intern' },
    { img: '/img/nagasatish.jpg', name: 'N. Naga Satish', role: 'Software Engineer - Intern' },
      { img: '/img/reethika.jpg', name: 'P. Reethika', role: 'Software Engineer - Intern' },
      { img: '/img/Sathwik.jpg', name: 'R. Satwik', role: 'Software Engineer - Intern' },
      { img: '/img/Ajaysai.jpg', name: 'K. Ajay Sai', role: 'Software Engineer - Intern' },
      { img: '/img/vamshi.jpg', name: 'M. Vamshi Vardhan', role: 'Software Engineer - Intern' },
      { img: '/img/vishnuvardhan.jpg', name: 'Ch. Vishnu Vardhan', role: 'Software Engineer - Intern' },
      { img: '/img/Anoosh.jpg', name: 'D. Anoosh Babu', role: 'Software Engineer - Intern' },
      { img: '/img/karthik.jpg', name: 'G. KarthikChary', role: 'Software Engineer - Intern' },
      { img: '/img/vamsikrishna.png', name: 'Ch. Vamsi Krishna', role: 'Software Engineer - Intern' },
      { img: '/img/Chathurya.jpeg', name: 'K. Chathurya', role: 'Digital Marketing - Intern' },
      { img: '/img/hrintern.jpeg', name: 'D. Laharika', role: 'HR Executive - Intern' },
      
      
  ], []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* ================= HERO ================= */}
      <header className="relative w-full">
        <div
          className="relative w-full h-[317px] bg-center bg-cover bg-no-repeat"
         style={{ backgroundImage: "url(/img/ourinterns.png)" }}

        >
          <div className="absolute inset-0 bg-black/70 lg:bg-black/60" />

          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 drop-shadow-md">
              Our Interns
            </h1>

            <div className="flex items-center gap-2 text-sm sm:text-base">
              <Link to="/" className="hover:underline">Home</Link>

              <svg width="7" height="10" viewBox="0 0 7 10" fill="none">
                <path
                  d="M0.297 0.262C0.105 0.426 -0.002 0.648 0 0.878C0.002 1.109 0.113 1.329 0.308 1.492L4.02 4.604L0.366 7.711C0.173 7.875 0.067 8.097 0.069 8.328C0.071 8.558 0.182 8.778 0.377 8.941C0.474 9.022 0.59 9.086 0.717 9.13C0.844 9.174 0.981 9.196 1.118 9.195C1.255 9.194 1.391 9.171 1.518 9.126C1.644 9.081 1.758 9.016 1.854 8.933L6.232 5.212C6.329 5.131 6.405 5.034 6.457 4.927C6.509 4.821 6.535 4.706 6.534 4.591C6.533 4.476 6.505 4.362 6.451 4.256C6.397 4.15 6.319 4.054 6.221 3.974L1.774 0.254C1.677 0.173 1.561 0.109 1.434 0.065C1.307 0.021 1.171 -0.001 1.033 0C0.896 0.001 0.76 0.024 0.634 0.069C0.507 0.114 0.393 0.18 0.297 0.262Z"
                  fill="white"
                />
              </svg>

              <span>Our Interns</span>
            </div>
          </div>
        </div>
      </header>

      {/* ================= CONTENT ================= */}
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-16">

        {/* ====== InternXperts Section ====== */}
        <div className="grid md:grid-cols-2 gap-10 lg:gap-16 items-center mb-20">
          <div className="relative order-2 md:order-1">
            <div className="absolute inset-0 bg-gray-300 rounded-tr-[100px] rounded-bl-[100px] -z-10"></div>

            <img
              src="/img/internheader.png"
              alt="Interns working"
              className="relative rounded-tr-[100px] rounded-bl-[100px] w-full h-80 sm:h-96 object-cover shadow-2xl"
            />

            {/* <div className="absolute -top-4 -left-4 w-24 h-24 border-4 border-blue-600 rounded-lg" /> */}
          </div>

          <div className="order-1 md:order-2">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-indigo-950 mb-4">
              InternXperts at LauraTek
            </h2>

            <h3 className="text-2xl sm:text-3xl font-semibold text-black mb-6 leading-tight">
              Developing Future Leaders. Creating Real-World Impact.
            </h3>

            <p className="text-zinc-600 text-base sm:text-lg leading-relaxed mb-8">
              At LauraTek, the learning and innovation division of SecurXpert Technologies Pvt. Ltd., internships go beyond theory and classroom lessons.
Our interns work on real-time products developed by SecurXpert, gaining practical experience and understanding how professional software projects are built and delivered.
They collaborate with expert mentors, learn new technologies, and contribute to live projects that solve real industry problems.
            </p>
          </div>
        </div>

        {/* ====== Meet Our InternXperts ====== */}
        <div className="mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-indigo-950 mb-6 text-center">
            OneStep Medi – Powered by Intern Talent
          </h2>

          <p className="text-xl sm:text-2xl text-zinc-600 text-center mb-10 max-w-4xl mx-auto">
            Where Vision Meets Real-World Value
          </p>

          <h3 className="text-2xl sm:text-3xl font-semibold text-black text-center mb-12">
            Meet Our InternXperts
          </h3>

          {/* ===== Intern Cards ===== */}
         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
  {interns.map((intern, idx) => (
    <div
      key={idx}
      className="group relative rounded-2xl overflow-hidden shadow-lg bg-white
                 transition-transform duration-300 hover:-translate-y-2"
      style={{ height: "420px" }}   // ✅ SAME CARD HEIGHT
    >
      {/* Image */}
      <div className="relative h-[320px] overflow-hidden">
        <img
          src={intern.img}
          alt={intern.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
      </div>

      {/* Info */}
      <div
       className="bg-[#3E66F3]/90 backdrop-blur-sm 
             h-[130px] p-4 text-white 
             flex flex-col justify-center"
>
        <h4 className="text-base font-bold leading-tight">
          {intern.name}
        </h4>
        <p className="text-xs opacity-90 mt-1 line-clamp-2">
          {intern.role}
        </p>
      </div>
    </div>
  ))}
</div>

        </div>

        {/* ===== Why Our InternXperts Shine ===== */}
        <div className="mb-10">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-indigo-950 text-center mb-16">
            Why Our InternXperts Shine
          </h2>

          <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div className="relative flex justify-center">
              <img
                src="/img/ourintern.png"
                alt="Team"
                className="w-80 sm:w-96 md:w-[420px] lg:w-[480px] rounded-2xl "
              />
            </div>

            <div className="space-y-10">
              {[
                { title: "Hands-On Innovation", desc: "Actively involved in developing a healthcare platform scheduled for launch in 2025." },
                { title: "Meaningful Mentorship", desc: "Guided by experienced engineers and industry experts to build real-world skills." },
                { title: "Real Ownership", desc: "Interns contributed deployable code and real features, not just ideas." },
                { title: "Cross-Disciplinary Learning", desc: "Applied EdTech and technical knowledge to solve HealthTech challenges." },
              ].map((feature, index) => (
                <div key={index} className="flex gap-6 items-start">
                  <div className="flex-shrink-0 w-12 h-12 bg-indigo-950 text-white rounded-full flex items-center justify-center text-2xl font-bold">
                    {index + 1}
                  </div>

                  <div className="pt-1">
                    <p className="text-lg sm:text-xl text-zinc-700 leading-relaxed">
                      <span className="font-bold text-indigo-950">{feature.title} — </span>
                      {feature.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />

      {/* ===== Scroll-To-Top Button ===== */}
      {showScroll && (
        <div
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-lg hover:from-blue-600 hover:to-blue-800 transition-all"
        >
          <svg className="progress-circle -rotate-90 w-12 h-12 absolute" viewBox="-1 -1 102 102">
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              fill="none"
              stroke="white"
              strokeWidth="4"
              strokeDasharray="307.919"
              strokeDashoffset={307.919 - (307.919 * scrollProgress / 100)}
              style={{ transition: "stroke-dashoffset 0.2s linear" }}
            />
          </svg>

          <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-white relative z-10" fill="none"
            viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
          </svg>
        </div>
      )}
    </div>
  );
};

export default OurInterns;
